import { Application } from "@hotwired/stimulus"
import { Autocomplete } from 'stimulus-autocomplete'

const application = Application.start()
application.register('autocomplete', Autocomplete)

// Set debug to true to enable Stimulus console logging
application.debug = false
window.Stimulus   = application

export { application }
